

import React, { useEffect, useState } from "react";
import "./css/admin.css";
import { Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { toastError } from "../utils/toast";
import { getDashboardStats } from "../api/dashboardApi"; // <-- use per-user stats API

export default function LawyerDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.id; // 👈 pull id for query param
  const displayName = user?.name || "User";
  const displayRole = user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : "";

  const loadStats = async () => {
    if (!userId) {
      toastError("User not found in localStorage");
      return;
    }
    setLoading(true);
    try {
      // Hit /dashboard/get-stats?user_id=<id>
      const data = await getDashboardStats(userId);
      if (data?.status !== true) {
        throw new Error(data?.message || "Failed to load stats");
      }
      setStats({
        pending: data.pending ?? 0,
        accepted: data.accepted ?? 0,
        rejected: data.rejected ?? 0,
        resolved: data.resolved ?? 0,
        total: data.total ?? 0,
      });
    } catch (err) {
      toastError(err?.message || "Failed to load stats");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Lawyer quick actions
  const quickActions = [
    { label: "View Service Requests", type: "primary", onClick: () => navigate("/lawyer/requests") },
  ];

  const StatSkeletonCard = () => (
    <div className="stat-card">
      <Skeleton.Input active style={{ width: 160, marginBottom: 8 }} />
      <Skeleton.Input active style={{ width: 100, height: 32 }} />
    </div>
  );

  return (
    <>
      <h1 className="dash-title">
        Dashboard <span className="dash-user">– {displayName} ({displayRole})</span>
      </h1>

      <div className="dashboard-container">
        {/* Per-lawyer status counts */}
        {loading || !stats ? (
          <div className="stats-grid">
            {Array.from({ length: 5 }).map((_, i) => (
              <StatSkeletonCard key={i} />
            ))}
          </div>
        ) : (
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-label">Pending Services</div>
              <div className="stat-value">{stats.pending}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Accepted Services</div>
              <div className="stat-value">{stats.accepted}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Rejected Services</div>
              <div className="stat-value">{stats.rejected}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Resolved Services</div>
              <div className="stat-value">{stats.resolved}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Total Services</div>
              <div className="stat-value">{stats.total}</div>
            </div>
          </div>
        )}

        {/* Quick actions */}
        <aside className="quick-actions">
          <h3>Quick Actions</h3>
          {loading || !stats ? (
            <>
              <Skeleton.Button active block style={{ height: 40, marginBottom: 10 }} />
              <Skeleton.Button active block style={{ height: 40, marginBottom: 10 }} />
              <Skeleton.Button active block style={{ height: 40 }} />
            </>
          ) : (
            quickActions.map((action) => (
              <button
                key={action.label}
                className={`qa-btn ${action.type}`}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))
          )}
        </aside>
      </div>
    </>
  );
}
